import React from 'react';

const Rating = (movie) => (
  <div className="rating ">{ movie.rating }</div>);

export default Rating;
